import {
  PALETTES,
  paletteGradientCSS,
  getPaletteId,
  setPalette,
  onPaletteChange
} from '../utils/colors.js';

/**
 * "Farbskala"-Auswahl im Einstellungs-Panel: hinter einem Button versteckt, der
 * die aktuelle Palette (Name + Mini-Gradient) zeigt und beim Klick die Auswahl
 * aufklappt. Bei Auswahl werden Karte (Icons, Trails, Bodenpunkte) und die
 * Höhen-Legende sofort neu eingefärbt.
 */
export function setupColorScale(flightManager) {
  const container = document.getElementById('palettePicker');
  const legendGradient = document.querySelector('#altitudeLegend .legend-gradient');
  const toggle = document.getElementById('paletteToggle');
  const toggleBar = document.getElementById('paletteToggleBar');
  const toggleName = document.getElementById('paletteToggleName');
  if (!container) return;

  function syncLegend() {
    if (legendGradient) {
      legendGradient.style.background = paletteGradientCSS(getPaletteId(), 'to top');
    }
  }

  // Aktuelle Auswahl in der Button-Vorschau spiegeln
  function syncToggle(id) {
    if (toggleBar) toggleBar.style.background = paletteGradientCSS(id, 'to right');
    if (toggleName) toggleName.textContent = PALETTES[id]?.name || '';
  }

  function setOpen(open) {
    if (!toggle) return;
    container.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    toggle.classList.toggle('open', open);
  }

  if (toggle) {
    toggle.addEventListener('click', () => {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });
  }

  // Swatches aus den Palettendefinitionen bauen (bleibt garantiert konsistent)
  container.innerHTML = '';
  for (const [id, palette] of Object.entries(PALETTES)) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'palette-swatch';
    btn.dataset.palette = id;
    btn.title = palette.name;
    btn.setAttribute('aria-label', palette.name);

    const bar = document.createElement('span');
    bar.className = 'palette-bar';
    bar.style.background = paletteGradientCSS(id, 'to right');

    const name = document.createElement('span');
    name.className = 'palette-name';
    name.textContent = palette.name;

    btn.append(bar, name);
    btn.addEventListener('click', () => {
      setPalette(id);
      setOpen(false); // nach Auswahl wieder zuklappen
    });
    container.appendChild(btn);
  }

  function reflect(id) {
    container.querySelectorAll('.palette-swatch').forEach((btn) => {
      const active = btn.dataset.palette === id;
      btn.classList.toggle('active', active);
      btn.setAttribute('aria-pressed', String(active));
    });
  }

  reflect(getPaletteId());
  syncLegend();
  syncToggle(getPaletteId());

  onPaletteChange((id) => {
    reflect(id);
    syncLegend();
    syncToggle(id);
    flightManager.refreshColors();
  });
}
